import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, Mail, MailCheck } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Field } from "@/pages/Login";

export default function Recuperar() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      await api.post("/auth/recuperar", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F5] flex items-center justify-center px-5 py-10">
      <div className="w-full max-w-md aldia-fade-up">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-2xl bg-[#3A6B56] flex items-center justify-center mx-auto">
            <ShieldCheck size={34} className="text-white" />
          </div>
          <h1 className="font-heading text-3xl font-bold text-[#1C2421] mt-4">Recuperar contraseña</h1>
          <p className="text-base text-[#6E7A74] mt-1">Te enviaremos un enlace seguro a tu correo.</p>
        </div>

        {sent ? (
          <div className="bg-white border border-[#E5DFD5] rounded-2xl p-6 shadow-sm text-center" data-testid="recuperar-sent">
            <MailCheck size={44} className="text-[#3A6B56] mx-auto" />
            <p className="text-base text-[#1C2421] mt-3 leading-relaxed">
              Si existe una cuenta con <strong>{email}</strong>, recibirás un correo con
              instrucciones para crear una nueva contraseña. El enlace caduca en 1 hora.
            </p>
            <Link to="/login" className="inline-block mt-5 font-bold text-[#3A6B56]">Volver a iniciar sesión</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-white border border-[#E5DFD5] rounded-2xl p-6 shadow-sm space-y-4">
            <Field icon={Mail} label="Correo electrónico" type="email" value={email} onChange={setEmail} placeholder="tucorreo@ejemplo.com" testid="recuperar-email" />
            {error && <p className="text-sm font-semibold text-[#B91C1C] bg-[#FEF2F2] rounded-xl p-3">{error}</p>}
            <button data-testid="recuperar-submit" disabled={busy} className="w-full min-h-[56px] rounded-xl bg-[#3A6B56] text-white font-semibold text-lg hover:bg-[#2E5645] transition-colors disabled:opacity-60">
              {busy ? "Enviando…" : "Enviar enlace de recuperación"}
            </button>
            <p className="text-center text-base text-[#6E7A74]">
              <Link to="/login" className="font-bold text-[#3A6B56]">Volver</Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
